const GambiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111467)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0002 0C11.7318 0 4.63586 5.01766 1.58984 12.1739H38.4105C35.3645 5.01766 28.2685 0 20.0002 0Z"
        fill="#A2001D"
      />
      <path
        d="M20.0002 40.0011C28.2685 40.0011 35.3645 34.9834 38.4105 27.8271H1.58984C4.63586 34.9834 11.7318 40.0011 20.0002 40.0011Z"
        fill="#496E2D"
      />
      <path
        d="M39.311 14.7832H0.688984C0.240625 16.4467 0 18.1954 0 20.0006C0 21.8059 0.240625 23.5545 0.688984 25.218H39.3111C39.7594 23.5545 40 21.8059 40 20.0006C40 18.1954 39.7594 16.4467 39.311 14.7832Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111467">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GambiaSvg;
